// IT IMPACT brand logo — uses the official horizontal PNG.
// Sized to ~70% of header height for stronger brand presence.
const LOGO_WHITE =
  "https://customer-assets.emergentagent.com/job_impact-platform-demo/artifacts/rzq91sqh_LOGO%20-%20IT%20IMPACT_horizontal_white_transparent.png";
const LOGO_DARK =
  "https://customer-assets.emergentagent.com/job_impact-platform-demo/artifacts/r28hl72q_LOGO%20-%20IT%20IMPACT_horizontal_transparent.png";

export const Logo = ({ variant = "white" }) => {
  const src = variant === "dark" ? LOGO_DARK : LOGO_WHITE;
  return (
    <span
      data-testid="brand-logo"
      className="flex items-center group select-none"
      aria-label="IT IMPACT home"
    >
      <img
        src={src}
        alt="IT IMPACT"
        className="h-14 md:h-16 lg:h-[68px] w-auto object-contain shrink-0"
        loading="eager"
      />
    </span>
  );
};

export default Logo;
